// src/components/Footer.tsx
import React from 'react';
import { TextLink } from 'shared-portal-component';

const Footer: React.FC = () => (
  <footer className="w-full py-4 text-left text-sm bg-transparent text-white">
    <nav className="space-x-4 flex justify-center flex-wrap gap-4 w-1/2">
      <TextLink text="Terms of Service" href="https://six3ro.app.six3ro.com/terms" />
      <TextLink text="Privacy Policy" href="https://six3ro.app.six3ro.com/privacy" />
      <TextLink text="Contact Us" href="https://support.six3ro.com/portal/en/home" />
    </nav>
  </footer>
);

export default Footer;
